import { TreeSelect, type TreeNode } from "@/components/ui/chainSelector";
import { LabelField } from "../ui/label";

interface ChainProps {
	readonly value: string;
	readonly onChange: Setter<string>;
	readonly errors?: string[];
	readonly label?: string;
	readonly placeholder: string;
	readonly values: TreeNode[];
}
export function ChainSelectorInput(props: ChainProps) {
	const InputRender = (
		<TreeSelect
			value={props.value}
			onChange={props.onChange}
			placeholder={props.placeholder}
			data={props.values}
		/>
	);

	return (
		<div>
			{props.label ? (
				<LabelField label={props.label}>{InputRender}</LabelField>
			) : (
				InputRender
			)}

			{props.errors?.map((error) => (
				<div key={error} style={{ color: "red" }}>
					{error}
				</div>
			))}
		</div>
	);
}
